import { BASE_URL } from "../config/config";
import { builder } from "../utils/queryBuilder";
import Fetch from "./Fetch";

export const signInUser = async (body) =>
  await Fetch.post(`${BASE_URL}auth/linear/login-register`, body);

export const getAUserByToken = async () => await Fetch.get(`${BASE_URL}user`);

export const verifyNumber = async (body) =>
  await Fetch.post(`${BASE_URL}auth/linear/verify-login-register`, body);

export const forgetpassword = async (body) =>
  await Fetch.post(`${BASE_URL}/auth​/password​/forget`, body);

export const getAllUsers = (body) => {
  const params = builder({
    name: body.name,
    take: body.take,
    skip: body.skip,
    name_dir: body?.name_dir,
    created_at_dir: body?.created_at_dir,
  });
  return Fetch.get(`${BASE_URL}user/admin/all${params}`);
};
export const getAllPrintableUsers = (body) => {
  const params = builder({
    name: body.name,
    name_dir: body?.name_dir,
    created_at_dir: body?.created_at_dir,
  });
  return Fetch.get(`${BASE_URL}user/admin/all${params}`);
};

export const getAllBuyers = (id) => {
  return Fetch.get(`${BASE_URL}order-item/admin/${id}`);
};

export const getAUser = (body) => Fetch.get(`${BASE_URL}user/admin/id/${body}`);

export const deleteUser = (id) => Fetch.delete(`${BASE_URL}user/admin/${id}`);

export const updateUser = (id, body) =>
  Fetch.patch(`${BASE_URL}user/admin/${id}`, JSON.stringify(body), {
    headers: {
      "Content-Type": "application/json",
    },
  });

export const addNewUser = (body) => Fetch.post(`${BASE_URL}user/admin`, body);

export const updateUserProfile = (body) => Fetch.patch(`${BASE_URL}user`, body);
